// Lightweight pub/sub for "the server just renewed our session cookie".
//
// Sliding cookie expiry means every successful authenticated request resets
// the idle countdown server-side. The SPA's idle timer needs to mirror that
// behaviour, but the cookie is HttpOnly — we can't observe it directly. So
// the api() client publishes here on every 2xx response, and the
// SessionExpiryWatcher subscribes to keep its local countdown in sync.

type Callback = () => void;

const subscribers = new Set<Callback>();

/** Called by the api client after every successful authenticated response. */
export function notifySessionActive(): void {
  subscribers.forEach(cb => {
    try { cb(); } catch (err) { console.warn('session-active subscriber threw', err); }
  });
}

/** Subscribe; returns an unsubscribe function suitable for useEffect cleanup. */
export function onSessionActive(cb: Callback): () => void {
  subscribers.add(cb);
  return () => { subscribers.delete(cb); };
}
